import { ElementRef, Inject, Injectable, Type } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.state';
import { WINDOW } from '../../window.providers';
import * as moment from 'moment-timezone';
import { Moment } from 'moment-timezone';
import { ToastrService } from 'ngx-toastr';
import * as AppActions from '../../store/app/actions';
import { NgForm } from '@angular/forms';
import { MomentDateFormat, UserDateFormat } from '../helper/date.constants';
import { BulkResponseDataInterface } from '../model/interface/crud-response-interface.model';
import { ErrorMessageService } from './error-message.service';
import { CustomDateFormat } from '../../store/user/model';
import * as _ from 'lodash';
import sweetalert2, { SweetAlertOptions } from 'sweetalert2';
import {
  GenericCrudRequestConstructionParameterFilters,
  GenericCrudRequestConstructionParameters,
} from '../model/interface/generic-api-request.model';
import { DropdownComponent } from '../component/filter/dropdown/dropdown.component';
import { FilterableObjectTypes } from '../component/filter/filterable-objects.class';
import { RowConfigurationInterface } from '../component/filter/filter.class';
import { AdvancedFilterComponent } from '../component/filter/advanced-filter/advanced-filter.component';
import {
  AdvancedFilterClass,
  TargetEndpoints,
} from '../component/filter/advanced-filter/advanced-filter.model';
import { filter, take } from 'rxjs/operators';
import { IAdvancedFilterStore } from '../../store/advanced-filter/advanced-filter.model';
import { AdvancedFilterService } from '../component/filter/advanced-filter/advanced-filter.service';
import {
  DropdownOptionInterface,
  IDefaultSelectItem,
  ScwMatMaxLengthRule,
  ScwMatMaxValueRule,
  ScwMatMinValueRule,
  ScwMatRulesInterface,
  ScwMatSelectRule,
} from '../component/scw-mat-ui/scw-mat-select/scw-mat-select.model';
import { ScwMatInput } from '../component/scw-mat-ui/scw-mat-input/scw-mat-input.model';
import { DependencyType, DropdownSettingsInterface } from '../component/filter/dropdown/dropdown.model';
import { TimeZoneOptions } from '../model/enum/timezone-list';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { NonEmptyArray } from '../model/interface/generic.model';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ITableHeader, PageConfigurationTypes } from '../../../constants.model';
import { TabRowInterface } from '../component/side-config-bar/side-config-bar.model';
import * as UserConfigurationActions from '../../store/user-configuration/user-configuration.actions';
import {
  ComponentNamesForUserConfiguration,
  IComponentConfiguration,
  IUserConfiguration,
  UserConfigurationStateInterface,
} from '../../store/user-configuration/user-configuration.model';
import { WidgetConfigurationInterface } from '../component/page-configuration/page-configuration.model';
import { DateRanges, StatusesEnum, ELanguages, TOtherLanguageOptions } from '../../../constants';
import { ScwMatFormComponent } from '../component/scw-mat-ui/scw-mat-form/scw-mat-form.component';
import { IAllowedDomain } from '../../store/main/main.model';
import { IFilterMap, IFilterMapped } from '../component/file-generator/file-generator.model';
import { DropdownInterface } from '../../store/settings/users/users.model';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  public isTouchDevice: boolean;
  private decimalSeparator: '.' | ',';
  private thousandSeparator: string;
  private userDateFormat$: string;
  private userDateTimeFormat$: string;
  private userLocale$: string;
  public static userDatePref: { dateFormat: string; timeFormat: string; weekFormat: string };
  private timezone$: string;
  private successTitle: string;
  private changesSavedSuccessfullyMessage: string;
  private errorTitle: string;

  constructor(
    @Inject(WINDOW) private window: Window,
    private store: Store<AppState>,
    private toast: ToastrService,
    private errorMessageService: ErrorMessageService,
    private readonly advancedFilterService: AdvancedFilterService,
  ) {
    this.isTouchDevice = 'ontouchstart' in document.documentElement;

    this.store.select('user').subscribe((state) => {
      this.userDateFormat$ = state.dateFormat;
      this.userDateTimeFormat$ = state.dateTimeFormat;
      this.timezone$ = state.timezone;
      HelperService.getDateTimePref(state.dateFormat, state.dateFormat);
    });

  }

  formattedNumberToNumber(formattedNumber) {
    if (typeof formattedNumber === 'undefined' || formattedNumber === null || formattedNumber === '') {
      return 0;
    }

    const thousandRegex = this.thousandSeparator === '.' ? /[.]/g : /[,]/g;

    const decimalRegex = this.decimalSeparator === '.' ? /[.]/g : /[,]/g;

    return parseFloat(formattedNumber.replace(thousandRegex, '').replace(decimalRegex, '.'));
  }

  numberToFormattedNumber(number, decimalCount = 1) {
    if (typeof number !== 'number' || !isFinite(number)) {
      return 0;
    }

    const decimal = this.decimalSeparator;
    const thousands = this.thousandSeparator;
    let decimalCountVar = Math.abs(decimalCount);
    decimalCountVar = isNaN(decimalCountVar) ? 2 : decimalCountVar;

    const negativeSign = number < 0 ? '-' : '';

    let numberVar;
    const i: any = parseInt((numberVar = Math.abs(Number(number) || 0).toFixed(decimalCountVar)), 10).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
      (decimalCount
        ? decimal +
          Math.abs(numberVar - i)
            .toFixed(decimalCount)
            .slice(2)
        : '')
    );
  }

  markEmptyField(value) {
    let output = value;
    if (typeof value === 'undefined' || value === null || value === '') {
      output = '--';
    }
    return output;
  }

  getHostname(): string {
    return this.window.location.hostname;
  }

  scrollButton(element, position) {
    switch (position) {
      case 'up': {
        document.querySelector(`.modal.show ${element}`).scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
        break;
      }
      case 'down': {
        document.querySelector(`.modal.show ${element}`).scroll({
          top: 9999999,
          left: 0,
          behavior: 'smooth',
        });
        break;
      }
      default:
    }
  }

  calculateRate(dividend, denominator, isProgress = false): number | string | any {
    let rate;
    let decimalCountVal = 1;
    let dividendVal = dividend;
    let denominatorVal = denominator;

    if (
      typeof dividend === 'undefined' ||
      typeof denominator === 'undefined' ||
      dividend === null ||
      denominator === null ||
      dividend === '' ||
      denominator === ''
    ) {
      return 0;
    }

    if (typeof dividend !== 'number') {
      dividendVal = this.formattedNumberToNumber(dividend);
    }

    if (typeof denominator !== 'number') {
      denominatorVal = this.formattedNumberToNumber(denominator);
    }

    if (denominatorVal === 0) {
      return 0;
    }

    rate = (dividendVal / denominatorVal) * 100;

    if (isProgress && rate <= 0) {
      return 0;
    }

    if (isProgress && rate >= 100) {
      return 100;
    }

    if (isProgress) {
      return rate;
    }

    if (!isProgress) {
      decimalCountVal = 0;
    }

    return this.numberToFormattedNumber(rate, decimalCountVal);
  }

  checkIsValidDateOrFail(date: any, format: string): void {
    const momentDate = moment(date, format, true);

    if (!momentDate.isValid()) {
      this.toast.error(('general.incorrectDateFormat'), ('general.error'), {
        closeButton: true,
        progressBar: true,
        positionClass: 'toast-bottom-right',
      });
      this.store.dispatch(new AppActions.HideTopLoader());
      this.store.dispatch(new AppActions.HideLoader());
      throw new Error('Invalid Date Format');
    }
  }

  getEditedFields<T>(form: NgForm): Partial<T> {
    let editedFields: Partial<T> = {};
    for (const [key, value] of Object.entries(form.form.controls)) {
      if (value.dirty) {
        editedFields = Object.assign(editedFields, { [key]: value.value });
      }
    }
    return editedFields;
  }

  public formatDuration(duration: number, withSecond: boolean = false, suffix: boolean = false) {
    if (duration === null) {
      return '';
    }

    let negative = '';

    if (duration < 0) {
      duration = duration * -1;
      negative = '-';
    }

    const hours: string = Math.floor(duration / 3600)
      .toString()
      .padStart(2, '0');
    const minutes: string = Math.floor((duration / 60) % 60)
      .toString()
      .padStart(2, '0');
    const seconds: string = (duration % 60).toString().padStart(2, '0');

    let shorteningHr = '';
    let shorteningMin = '';
    let shorteningSec = '';
    let separator = ':';

    if (suffix) {
      shorteningHr = ('general.shortHour');
      shorteningMin = ('general.shortMinute');
      shorteningSec = ('general.shortSecond');
      separator = ' ';
    }

    if (withSecond) {
      return `${negative}${hours}${shorteningHr}${separator}${minutes}${shorteningMin}${separator}${seconds}${shorteningSec}`;
    }

    return `${negative}${hours}${shorteningHr}${separator}${minutes}${shorteningMin}`;
  }

  public minutesToFormattedHm(duration: number): string {
    let formattedDuration: string = '0';
    let hours: number = Math.floor(duration / 3600);
    const shortDay: string = ('general.shortDay');
    const shortHour: string = ('general.shortHour');
    const shortMinute: string = ('general.shortMinute');
    const days: number = Math.floor(duration / 86400);
    const minutes: number = Math.floor((duration - hours * 3600) / 60);

    if (days > 0) {
      hours = hours - 24 * days;

      formattedDuration = `${days}${shortDay} ${hours}${shortHour} ${minutes}${shortMinute}`;
    } else if (hours > 0) {
      formattedDuration = `${hours}${shortHour} ${minutes}${shortMinute}`;
    } else if (minutes > 0) {
      formattedDuration = `${minutes}${shortMinute}`;
    }

    return formattedDuration;
  }

  public pageSizeFormatter(pageSize: number) {
    let fixedPageSize = 10;

    if (10 < pageSize && pageSize <= 25) {
      fixedPageSize = 25;
    }

    if (25 < pageSize && pageSize <= 50) {
      fixedPageSize = 50;
    }

    if (50 < pageSize && pageSize <= 100) {
      fixedPageSize = 100;
    }
    return fixedPageSize;
  }

  public decimalToNumberFormatter(value: number | string): number {
    if (value === null) {
      return null;
    }

    const formatted: string = this.decimalSeparator === ',' ? value.toString().replace(/\,/g, '.') : value.toString();

    return Number(formatted);
  }

  public decimalToStringFormatter(value: number | string): string {
    if (value === null) {
      return null;
    }

    return this.decimalSeparator === ',' ? value.toString().replace(/\./g, ',') : value.toString().replace(/\,/g, '.');
  }

  getUserMomentTimeFormat(): MomentDateFormat.TIME_12H | MomentDateFormat.TIME_24H {
    return this.userDateFormat$ === UserDateFormat.DATETIME_12H ? MomentDateFormat.TIME_12H : MomentDateFormat.TIME_24H;
  }

  public showToastMessage(success: boolean, title: string | undefined, message: string): void {
    const defaultTitle: string = success ? this.successTitle : this.errorTitle;
    const type: string = success ? 'success' : 'error';

    this.toast[type](message, title ?? defaultTitle, {
      closeButton: true,
      progressBar: true,
      positionClass: 'toast-bottom-right',
    });
  }

  public decimalToPercentageFormat(value: number | string, decimalCount: number = 2): string | null {
    if (value === null || isNaN(Number(value))) {
      return null;
    }

    return this.decimalToStringFormatter(Number(value).toFixed(decimalCount));
  }

  public toastBulkErrors(response: BulkResponseDataInterface): void {
    if (response && response.data) {
      this.errorMessageService.getTranslatedErrorMessage(response.data);

      for (const message of response.data) {
        if (!message.success) {
          this.showToastMessage(
            message.success,
            ('general.failed'),
            (message.message || []).join(', '),
          );
        }
      }
    }
  }

  public setUserDateTimeFormat(
    date: string | Moment | Date,
    showTime: boolean = false,
    showYear: boolean = true,
  ): string {
    if (date === null || date === '') {
      return '';
    }

    let dateFormat = this.userDateFormat$;
    let formattedDate: string;

    if (showTime) {
      dateFormat = this.userDateTimeFormat$;
    }

    if (moment(date).isValid()) {
      formattedDate = moment(date).format(dateFormat);
    } else if (moment(date, dateFormat).isValid()) {
      formattedDate = moment(date, dateFormat).format(dateFormat);
    }

    if (!showYear) {
      formattedDate = this.removeYear(moment(date), formattedDate);
    }

    return formattedDate;
  }

  public setCustomDateFormats(): CustomDateFormat {
    return {
      parseInput: 'LL LT',
      fullPickerInput: this.userDateTimeFormat$,
      datePickerInput: this.userDateFormat$,
      timePickerInput: 'H:mm',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
    };
  }

  public setLocale(): string {
    return this.userLocale$;
  }

  public getPlaceholderForDate(showTime: boolean = false): string {
    const now = showTime
      ? moment().tz(this.timezone$).format(this.userDateTimeFormat$)
      : moment().tz(this.timezone$).format(this.userDateFormat$);
    return ('general.datePlaceholder');
  }


  public calculatePhaseDuration(duration: string): string {
    if (duration === null) {
      return null;
    }

    return (Number(duration) / 3600).toFixed(1);
  }

  public removeYear(moment: moment.Moment, dateString: string): string {
    const regex: RegExp = new RegExp(`[^]${moment.format('Y')}`);
    return dateString.replace(regex, '');
  }

  public static getDateTimePref(timeFormat: string, dateFormat: string): void {
    const userDatePref = {
      timeFormat: 'h:mm a',
      dateFormat: 'ddd MM/DD',
      weekFormat: 'w.W MMM/YYYY',
    };

    if (timeFormat === 'MMM D, YYYY H:mm') {
      userDatePref.timeFormat = 'H:mm';
    }

    if (dateFormat === 'MM/DD/YYYY') {
      userDatePref.dateFormat = 'ddd DD/MM';
    }

    HelperService.userDatePref = userDatePref;
  }

  public static mergeArrayObjectsBy(originalArray: any[], updateArray: any[], iterator: string): any[] {
    return originalArray.map((item: any) => {
      const updateArrayIndex = updateArray.find((element: any) => element[iterator] === item[iterator]);
      return updateArrayIndex ? Object.assign({}, item, updateArrayIndex) : item;
    });
  }

  public static transformToBoolean(value: unknown): boolean | unknown {
    if (_.isNil(value) || _.isBoolean(value)) {
      return value;
    }

    try {
      const parsedValue = JSON.parse(String(value));

      return [1, 0, true, false].includes(parsedValue) ? Boolean(parsedValue) : value;
    } catch {
      return value;
    }
  }

  public static prepareDecimalValue(decimal: number, decimalSeparator: ',' | '.'): number | string {
    if (decimalSeparator === '.') return decimal;

    return String(decimal).replace('.', ',');
  }

  public showSweetAlertError(text: string, settings?: SweetAlertOptions): void {
    this.store.dispatch(new AppActions.HideLoader());
    sweetalert2({
      text,
      showCancelButton: false,
      title: ('general.error'),
      confirmButtonText: ('general.ok'),
      type: 'error',
      ...settings,
    }).catch(sweetalert2.noop);
  }


  public getActiveInactiveOfStatus(): IDefaultSelectItem[] {
    return [
      { id: StatusesEnum.ACTIVE, name: ('general.active') },
      { id: StatusesEnum.INACTIVE, name: ('general.inactive') },
    ];
  }

  public getGenericDropdownFilter(
    entity: {
      type: Type<FilterableObjectTypes>;
      name: string;
    },
    cls: string = 'col-md-3 m-t-5 m-b-5',
    overrideOptions: Partial<DropdownSettingsInterface> = {},
    depends?: DependencyType,
  ): RowConfigurationInterface {
    return {
      cls,
      elementId: `${entity.name}Dropdown`,
      type: DropdownComponent,
      object: entity.type,
      outputOptions: {
        filterObjectId: entity.name,
        filterObjectProp: 'id',
        returnFilterObjectAllProp: false,
      },
      options: {
        isRequired: false,
        singleSelection: false,
        badgeShowLimit: 1,
        text: (`filterCard.${entity.name}.dropdownPlaceHolder`),
        enableSearchFilter: true,
        ...overrideOptions,
      },
      ...(depends ? { depends } : {}),
    };
  }

  public getGenericAdvancedFilter(
    advancedFilterObject: Type<AdvancedFilterClass>,
    cls: string = 'col-md-4 m-t-5 m-b-5',
    elementId: string = 'advancedFilter',
  ): RowConfigurationInterface {
    return {
      advancedFilterObject,
      cls,
      elementId,
      type: AdvancedFilterComponent,
      outputOptions: {
        filterObjectId: 'advancedFilter',
      },
      options: {
        isRequired: false,
        autoApply: true,
      },
    };
  }

  public pageFilterChangeOperations(
    event: any,
    pageData: {
      pageDataCrudParameters: GenericCrudRequestConstructionParameters;
      pageName: string;
      isFirstTimeOpening: boolean[];
      selectedItems: unknown[];
    },
    additionalOperations: Function,
    target: TargetEndpoints = TargetEndpoints.NestJSCrud,
  ): void {
    this.store
      .select('advancedFilterStore')
      .pipe(
        filter((state: IAdvancedFilterStore) => !state.isDefaultFiltersLoading && state.isDefaultFiltersLoaded),
        take(1),
      )
      .subscribe((state: IAdvancedFilterStore) => {
        pageData.pageDataCrudParameters.page = 1;

        if (pageData.isFirstTimeOpening[0]) {
          pageData.pageDataCrudParameters.advancedFilter = {
            target,
            filters: [],
            page: pageData.pageName,
          };

          if (!_.isEmpty(_.get(state.defaultFilters, pageData.pageName, null))) {
            pageData.pageDataCrudParameters.advancedFilterPage = pageData.pageName;
            pageData.pageDataCrudParameters.advancedFilter.filters = this.advancedFilterService.prepareForOutput(
              state.defaultFilters[pageData.pageName],
            );
          }

          pageData.isFirstTimeOpening[0] = false;
        } else if (event.advancedFilter !== null) {
          pageData.pageDataCrudParameters.advancedFilter = _.get(event, 'advancedFilter', null);
          pageData.pageDataCrudParameters.advancedFilterPage = pageData.pageName;
        }

        pageData.selectedItems = [];
        pageData.pageDataCrudParameters.filters = [
          ...(Array.isArray(event.site) ? [{ field: 'siteId', ids: event.site }] : []),
          ...(Array.isArray(event.line) ? [{ field: 'lineId', ids: event.line }] : []),
        ];

        additionalOperations();
      });
  }

  public selectOrUnselectAllCheckboxes(
    isSelectAll: boolean,
    elementRef: ElementRef,
    componentName: string,
    pageData: { id: number }[],
  ): void {
    if (elementRef.nativeElement.querySelector(`[id^="${componentName}-checkbox-"]`) !== null) {
      pageData.forEach((item) => {
        const checkbox = _.head(
          document.getElementById(`${componentName}-checkbox-${item.id}`).getElementsByTagName('input'),
        );

        if ((isSelectAll && !checkbox.checked) || (!isSelectAll && checkbox.checked)) {
          checkbox.click();
        }
      });
    }
  }

  public onDatatableRowClicked($event, componentName: string): void {
    const { event, item } = $event;
    const index = Array.from(event.target.parentElement.children).indexOf(event.target);

    if (
      index !== 0 ||
      event.target.classList.contains('mat-checkbox-inner-container') ||
      event.target.tagName !== 'TD' ||
      HelperService.preventDatatableRowClick(event)
    ) {
      return;
    }

    _.head(document.getElementById(`${componentName}-checkbox-${item.id}`).getElementsByTagName('input')).click();
  }

  private static preventDatatableRowClick(event): boolean {
    let tagName = event.target.tagName;
    let element = event.target;
    let prevent = false;

    while (tagName !== 'TD' && element) {
      tagName = element.parentElement?.tagName;
      element = element.parentElement;

      if (element?.classList.contains('prevent-datatable-row-click')) {
        prevent = true;
        break;
      }
    }

    if (element.firstElementChild?.classList?.contains('prevent-datatable-row-click')) {
      prevent = true;
    }

    return prevent;
  }

  public onBulkEditCheckboxChange(
    inputParameters: {
      value: boolean;
      index: string;
      formComponentInstance: ScwMatInput;
      defaultValue?: any;
    },
    inputFormParameters: {
      form: any;
      rules: ScwMatRulesInterface;
      areAnyOfTheBulkEditFormSelectBoxesSelected: string;
      isBulk: boolean;
      dropdownOptions: { [dropdownName: string]: DropdownOptionInterface[] };
    },
    dependentInputParameters?: {
      index: string;
      formComponentInstance: ScwMatInput;
    }[],
  ): void {
    if (inputParameters.value) {
      _.set(
        inputFormParameters.form,
        `${inputParameters.index}.rules`,
        _.get(inputFormParameters.rules, inputParameters.index),
      );

      if (inputParameters.defaultValue !== undefined) {
        _.set(inputFormParameters.form, `${inputParameters.index}.value`, inputParameters.defaultValue);
      }
    } else {
      inputParameters.formComponentInstance.reset();
      _.set(inputFormParameters.form, `${inputParameters.index}.rules`, []);
      _.set(
        inputFormParameters.form,
        `${inputParameters.index}.value`,
        Array.isArray(_.get(inputFormParameters.form, `${inputParameters.index}.value`)) ? [] : null,
      );

      for (const dependentInput of dependentInputParameters ?? []) {
        dependentInput.formComponentInstance.reset();
        _.set(inputFormParameters.form, `${dependentInput.index}.rules`, []);
        _.set(
          inputFormParameters.form,
          `${dependentInput.index}.value`,
          Array.isArray(_.get(inputFormParameters.form, `${dependentInput.index}.value`)) ? [] : null,
        );
        _.set(inputFormParameters.form, `${dependentInput.index}.isEnabled`, false);
        _.set(inputFormParameters.dropdownOptions, dependentInput.index, []);
      }
    }

    inputFormParameters.areAnyOfTheBulkEditFormSelectBoxesSelected = _.findKey(inputFormParameters.form, (item) => {
      return item.isEnabled;
    });
  }

  public getRequiredFormRule(): ScwMatSelectRule {
    return {
      required: true,
      message: ('scwMatForm.validation.required'),
    };
  }

  public getMaxLengthFormRule(maxLength: number): ScwMatMaxLengthRule {
    return {
      maxLength,
      message: ('scwMatForm.validation.maxLength'),
    };
  }

  public getMinValueFormRule(minValue: number): ScwMatMinValueRule {
    return {
      minValue,
      message: ('scwMatForm.validation.minValue'),
    };
  }

  public getMaxValueFormRule(maxValue: number): ScwMatMaxValueRule {
    return {
      maxValue,
      message: ('scwMatForm.validation.maxValue'),
    };
  }

  public getYesNoDropdown(): DropdownInterface[] {
    return [
      { id: 0, name: ('general.no') },
      { id: 1, name: ('general.yes') },
    ];
  }

  public getActiveInactive(): DropdownInterface[] {
    return [
      { id: 0, name: ('general.inactive') },
      { id: 1, name: ('general.active') },
    ];
  }

  public getDateTimeFormats(selectedLocale: string): DropdownInterface[] {
    return [
      { id: 'll', name: moment().locale(selectedLocale).format('ll LT') },
      { id: 'L', name: moment().locale(selectedLocale).format('L LT') },
    ];
  }

  public getTimezones(): DropdownInterface[] {
    return Object.entries(TimeZoneOptions).map(([key, value]) => ({ id: key, name: value })) as DropdownInterface[];
  }
  public nest<T>(seq: unknown, keys: NonEmptyArray<string>): T {
    if (!keys.length) {
      return seq as T;
    }

    const first: string = keys[0];
    const rest: string[] = keys.slice(1);
    return _.mapValues(_.groupBy(seq, first), (value) => {
      return this.nest(value, rest as NonEmptyArray<string>);
    });
  }

  public static formatDropdownFilterOptionOutput<T>(output: T[] | T): -1 | T[] | T {
    return (output?.[0] ?? -1) === -1 ? -1 : output;
  }

  public getFiltersFromFilterCardEvent($event): GenericCrudRequestConstructionParameterFilters[] {
    return _.toPairs($event).reduce(
      (dropdownFilters: GenericCrudRequestConstructionParameterFilters[], [key, value]) => {
        if (!_.isNil(key) && !_.isNil(value) && !_.isNil(_.fromPairs([key, value])) && Array.isArray(value)) {
          const filter: GenericCrudRequestConstructionParameterFilters = {
            field: key,
            ids: value,
          };
          dropdownFilters.push(filter);
        }

        return dropdownFilters;
      },
      [],
    );
  }

  public onChangeTableCheckBox<T, F>(event: MatCheckboxChange, items: number[], pageData: T[]): F {
    const inputValue: number = Number(event?.source?.value);

    if (event.checked) {
      items.push(inputValue);
    } else {
      items.splice(items.indexOf(inputValue), 1);
    }

    return _.find(pageData, { id: items[0] });
  }

  public showGenericChangesSavedSuccessfullyToastMessage(message: string = this.changesSavedSuccessfullyMessage): void {
    this.showToastMessage(true, undefined, message);
  }

  public static getSuccessAndFailedFromBulkResponse<T>(response: T[]): { fail: T[]; success: T[] } {
    return response.reduce(
      (filtered: { fail: T[]; success: T[] }, data) => {
        filtered[_.get(data, 'errorMessages') ? 'fail' : 'success'].push(data);

        return filtered;
      },
      { fail: [], success: [] },
    );
  }

  public getDefaultRanges(range: DateRanges): DateRanges {
    const temporaryRanges: DateRanges = {};

    const rangesLanguageMap = {
      today: 'Today',
      yesterday: 'Yesterday',
      thisWeek: 'This Week',
      lastWeek: 'Last Week',
      thisMonth: 'This Month',
      lastMonth: 'Last Month',
      thisYear: 'This Year',
      lastYear: 'Last Year',
    }
    Object.entries(_.cloneDeep(range) as DateRanges).forEach(([index, [start, end]]) => {
      const key = rangesLanguageMap[index];
      temporaryRanges[key] = [start.startOf('day'), end.add(1, 'days').startOf('day')];
    });

    return temporaryRanges;
  }

  public multipleModalDismiss(modals: NgbModalRef[]): void {
    for (const modal of modals) {
      if (modal) {
        modal.dismiss();
      }
    }
  }

  public onApplyClick(
    data: { payload: TabRowInterface[]; setAsDefault: boolean },
    defaultHeaderArray: ITableHeader[],
    insertToFirst: boolean,
    insertToLast: boolean,
    pageStore: string,
    componentName: ComponentNamesForUserConfiguration,
    customSetAsDefault: boolean = false,
  ): { headers: ITableHeader[];} {
    const rows = data.payload;
    let headers = [];

    if (insertToFirst) {
      headers = [defaultHeaderArray[0]];
    }

    rows.forEach((item) => {
      if (item.selected) {
        if (item.type === PageConfigurationTypes.TABLE) {
          const headerData = defaultHeaderArray.find((value: ITableHeader) => value.value === item.name);
          if (headerData.value !== null) {
            headers.push({ ...headerData, selected: true });
          }
        }
      }
    });

    if (insertToLast) {
      headers.push(defaultHeaderArray[defaultHeaderArray.length - 1]);
    }

    if (data.setAsDefault && !customSetAsDefault) {
      this.onSetAsDefault(pageStore, componentName);
    }

    return { headers };
  }

  public onSetAsDefault(pageStore: string, componentName: ComponentNamesForUserConfiguration): void {
    const dashboardModeAvailablePages = [
    ];
    let selectedColumns: TabRowInterface[] = [];
    this.store
      .select(pageStore)
      .pipe(take(1))
      .subscribe((state) => {
        selectedColumns = state.tableSettings;
      });

    const configuration: IUserConfiguration = {
      [componentName]: [
        {
          name: 'selectedColumns',
          value: selectedColumns.reduce((filtered, column) => {
            if (column.selected) {
              filtered.push({ name: column.name, type: column.type });
            }

            return filtered;
          }, []),
        },
      ],
    };

    for (const page of dashboardModeAvailablePages) {
      if (componentName !== page.regularName && componentName !== page.dashboardName) {
        continue;
      }

      let oldConfiguration: IComponentConfiguration[] = [];
      this.store
        .select('userConfigurationStore')
        .pipe(take(1))
        .subscribe((state: UserConfigurationStateInterface) => {
          oldConfiguration = _.cloneDeep(state.userConfigurationData[page.regularName] ?? []);
          _.remove(oldConfiguration, { name: 'isDashboardModeDefault' });

          if (componentName === page.regularName) {
            oldConfiguration = configuration[page.regularName];
          }
        });

      configuration[page.regularName] = [
        ...oldConfiguration,
        {
          name: 'isDashboardModeDefault',
          value: componentName === page.dashboardName,
        },
      ];

      break;
    }

    this.store.dispatch(new UserConfigurationActions.UpdateUserConfigurationLoading(configuration));
  }

  public setUserConfiguration(
    stateData,
    defaultHeaderArray: ITableHeader[],
    insertToFirst: boolean,
    insertToLast: boolean,
    isViewPage: boolean = false,
  ): { headers: ITableHeader[]; } {
    const tableSettings$ = stateData;
    const headers = [];

    if (!stateData) {
      defaultHeaderArray.forEach((item) => {
        if (item.selected) {
          headers.push(item);
        }
      });

    } else if (stateData && !isViewPage) {
      const selectedItems: { name: string; type: string }[] = _.get(
        _.find(tableSettings$, { name: 'selectedColumns' }),
        'value',
        [],
      );

      selectedItems.forEach((item: { name: string; type: string }) => {
        if (item.type === PageConfigurationTypes.TABLE) {
          const headerData = defaultHeaderArray.find((value: ITableHeader) => value.value === item.name);
          if (headerData !== undefined) {
            headers.push(headerData);
          }
        }
      });

      if (insertToFirst) {
        headers.splice(0, 0, defaultHeaderArray[0]);
      }

      if (insertToLast) {
        headers.splice(defaultHeaderArray.length - 1, 0, defaultHeaderArray[defaultHeaderArray.length - 1]);
      }
    } else if (isViewPage) {
      const selectedTableItems: string[] = _.get(_.find(tableSettings$, {name: 'tableColumns'}), 'value', []);
      const selectedWidgetItems: string[] = _.get(_.find(tableSettings$, {name: 'widgetSettings'}), 'value', []);

      selectedTableItems.forEach((item) => {
        const headerData = defaultHeaderArray.find((value: ITableHeader) => value.value === item);
        if (headerData !== undefined) {
          headers.push(headerData);
        }
      });

    }

    return { headers };
  }

  public filterChangeOperationsWithoutAdvancedFilter(
    event: any,
    pageData: {
      pageDataCrudParameters: GenericCrudRequestConstructionParameters;
      pageName: string;
      selectedItems: unknown[];
    },
  ): void {
    pageData.pageDataCrudParameters.page = 1;
    pageData.selectedItems = [];
    pageData.pageDataCrudParameters.filters = this.getFiltersFromFilterCardEvent(event);
  }

  public static getScwMatFormValuesWithDataPropertyKey(form: ScwMatFormComponent): { [p: string]: any } {
    const data: { [key: string]: any } = {};

    form.inputs?.forEach((input) => {
      data[input.dataPropertyKey] =
        _.isEmpty(input.inputModel) && typeof input.inputModel !== 'number'
          ? null
          : input.type === 'number' && !_.isNaN(Number(input.inputModel))
          ? Number(input.inputModel)
          : input.inputModel;
    });
    form.selects?.forEach((select) => {
      data[select.dataPropertyKey] = _.isEmpty(select.inputModel)
        ? null
        : select.singleSelection
        ? _.first(select.inputModel)[select.primaryKey]
        : select.inputModel?.map((item: any) => item[select.primaryKey]);
    });
    form.cronInputs?.forEach((input) => {
      data[input.dataPropertyKey] = _.isEmpty(input.inputModel) ? null : input.inputModel;
    });

    return data;
  }

  public static emailAllowedDomainMatch(input: string, allowedDomains: IAllowedDomain[]): boolean {
    const emailDomain = input?.split('@')?.[1];

    return emailDomain && allowedDomains.some((domain: IAllowedDomain) => domain.domain === emailDomain);
  }

  public getMappedFilteredValues(requestModel: IFilterMap): IFilterMapped[] {
    if (!requestModel) {
      return null;
    }

    const mappedValues: IFilterMapped[] = [];
    this.store
      .select(requestModel.storeName)
      .pipe(take(1))
      .subscribe((state: any) => {
        if (!state) {
          return;
        }
        let filter = [];
        const reqIds: number[] | number = requestModel.filteredDataIds;

        if (reqIds === -1 || reqIds === undefined) {
          filter = state.data;
        } else {
          filter = state.data.filter((state: string | number) =>
            reqIds.toString().includes(state[requestModel.filterPrefix]),
          );
        }
        filter.map((prop) => {
          mappedValues.push({
            value: prop.hasOwnProperty(requestModel.expectedProperty) ? prop[requestModel.expectedProperty] : null,
            id: prop.hasOwnProperty('id') ? prop['id'] : null,
          });
        });
      });
    return mappedValues;
  }

  public getTranslation(userLanguage: ELanguages, translations: TOtherLanguageOptions, originalText: string): string {
    return HelperService.getTranslation(userLanguage, translations, originalText);
  }

  public static getTranslation(
    userLanguage: ELanguages,
    translations: TOtherLanguageOptions,
    originalText: string,
  ): string {
    if (_.isNil(userLanguage) || userLanguage === ELanguages.EN || _.isNil(translations)) {
      return originalText;
    }

    const userLanguageLowerCase: ELanguages = userLanguage.toLowerCase() as ELanguages;

    return !_.isNil(translations[userLanguageLowerCase]) && translations[userLanguageLowerCase].trim() !== ''
      ? translations[userLanguageLowerCase]
      : originalText;
  }

  public showWaitMessage(): void {
    this.toast.info(('general.pleaseWaitForLongProcess'), '', {
      closeButton: false,
      progressBar: false,
      positionClass: 'toast-bottom-right',
    });
  }

  public formatNumber(value: number): number | string {
    if (_.isNil(value) || typeof value !== 'number') {
      return null;
    }

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'decimal',
      maximumFractionDigits: 20,
    });

    const [intPart, decimalPart] = formatter.format(value).split('.');
    return [intPart.replace(/[,]/g, this.thousandSeparator), ...(decimalPart ? [decimalPart] : [])].join(
      this.decimalSeparator,
    );
  }
}
